export const getCancelTimeString = (
    minHours: number
): string => {
    const daysStr = "dagar";
    const hoursStr = "timmar";
    const hourStr = "timme";
    const andStr = "och";
    if (minHours > 48 && minHours % 24 === 0) {
        const days = minHours / 24;
        return `${days} ${daysStr}`;
    } else if (minHours > 48) {
        const days = Math.floor(minHours / 24);
        const restHours = minHours % 24;
        if (restHours === 1) {
            return `${days} ${daysStr} ${andStr} ${restHours} ${hourStr}`;
        }
        return `${days} ${daysStr} ${andStr} ${restHours} ${hoursStr}`;
    } else {
        return `${minHours} ${hoursStr}`;
    }
};
